<div
    class="select-container me-2 truncate"
    style="padding-right: 10px"
    [ngClass]="{
        disabled:
            commonDataService.isOneTime ||
            (assignService.isNotAssignedToCurrentUser &&
                !commonDataService.user.isAdmin &&
                !commonDataService.user.isManager) ||
            commonDataService.user.isReadOnly,
    }"
    (click)="
        commonDataService.isOneTime ||
            (assignService.isNotAssignedToCurrentUser &&
                !commonDataService.user.isAdmin &&
                !commonDataService.user.isManager) ||
            commonDataService.user.isReadOnly ||
            checkCategoryChangeStatus()
    "
    tooltip="{{ 'Category' | translate }}: {{ ticket.category | categoryFullName }}"
    container="body"
    placement="auto">
    <span class="category-selector"> {{ ticket.category ? ticket.category.label : ('No category' | translate) }}</span>
</div>
